export interface QuizConfig {
	defaultQuizId: string;
}
export function loadQuizConfig(): QuizConfig {
	const { DEFAULT_QUIZ_ID } = process.env;

	return {
		defaultQuizId: DEFAULT_QUIZ_ID || "discover-cooking-style"
	};
}
